var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("create-transfer")))]),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-card-content" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-date-picker", {
                        attrs: { label: _vm.$ct("common.date.date") },
                        model: {
                          value: _vm.date,
                          callback: function ($$v) {
                            _vm.date = $$v
                          },
                          expression: "date",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input-number", {
                        attrs: { label: _vm.$ct("amount"), min: 0 },
                        model: {
                          value: _vm.amount,
                          callback: function ($$v) {
                            _vm.amount = $$v
                          },
                          expression: "amount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-select-bank-type", {
                        attrs: { label: _vm.$ct("common.from") },
                        model: {
                          value: _vm.fromBank,
                          callback: function ($$v) {
                            _vm.fromBank = $$v
                          },
                          expression: "fromBank",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-select-bank-type", {
                        attrs: { label: _vm.$ct("common.to") },
                        model: {
                          value: _vm.toBank,
                          callback: function ($$v) {
                            _vm.toBank = $$v
                          },
                          expression: "toBank",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: _vm.$ct("info") },
                        model: {
                          value: _vm.info,
                          callback: function ($$v) {
                            _vm.info = $$v
                          },
                          expression: "info",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "save", disabled: !_vm.valid },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }